import {
    DataMentionIdAttributeName,
    DataObjectKeyAttributeName,
    DataObjectType,
    DataObjectTypeAttributeName,
} from 'shared/content_editable/shared';

const MentionTagPattern =
    /\{\{mention:([0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12})\}\}/g;

// Replaces {{mention:UUID}} tokens with inline HTML spans that useTagPortals
// can later attach React portals to.
export function preprocessMentions(text: string): string {
    let counter = 0;
    return text.replace(MentionTagPattern, (_: string, mentionId: string) => {
        // eslint-disable-next-line no-plusplus
        const key = `${mentionId}-${counter++}`;
        return (
            `<span ` +
            `${DataObjectTypeAttributeName}="${DataObjectType.Mention}" ` +
            `${DataObjectKeyAttributeName}="${key}" ` +
            `${DataMentionIdAttributeName}="${mentionId}"` +
            `></span>`
        );
    });
}
